var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide-toggle-row"},[_c('div',{class:{
        'qrw-heading-xs': true,
        'v1-grey-10-color': true
      }},[_vm._t("default")],2),_c('BaseToggleSwitcher',{attrs:{"fillBg":"v1-grey-10","fillCircle":"v1-grey-10","value":_vm.value},on:{"input":function (v) { return _vm.$emit('input', v); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }